import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import colors from "assets/theme/base/colors";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { createRepeat } from "services/challenge-orders/challenge-orders.services";
import { dashboard } from "services/constants";
import PopUp from "./PopUp";

export function AppStatisticsCard({ bgColor, title, type, count, percentage, icon, direction }) {
  const { info } = colors;
  const [show, setShow] = useState(false);

  const showButton = (type, count) => {
    if (type === dashboard.REPEATS) {
      const countFormat = count.split(" ")[0];
      if (countFormat > 0) {
        setShow(true);
      }
    }
  }

  useEffect(() => {
    showButton(type, count);
  }, [type, count]);


  return (
    <Card sx={{ padding: "25px", height: "100%" }}>
      <VuiBox>
        <VuiBox>
          <Grid container alignItems="center">
            {direction === "left"
              ? (<Grid item>
                <VuiBox
                  bgColor={info}
                  color="#fff"
                  width="45px"
                  height="45px"
                  borderRadius="lg"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  shadow="md"
                >
                  {icon}
                </VuiBox>
              </Grid>)
              : null}
            <Grid item xs={icon ? 8 : 12}>
              <VuiBox ml={direction === "left" ? 2 : 0} lineHeight={1}>
                <VuiTypography
                  variant="caption"
                  color={bgColor === "white" ? "text" : "white"}
                  opacity={bgColor === "white" ? 1 : 0.7}
                  fontWeight={title.fontWeight}
                  fontSize="16px"
                >
                  {title.text}
                </VuiTypography>
                <VuiTypography
                  variant="subtitle1"
                  fontWeight="bold"
                  color="white"
                  fontSize="24px"
                  sx={({ breakpoints }) => ({
                    [breakpoints.down("md")]: {
                      fontSize: "20px",
                    },
                    [breakpoints.only("lg")]: {
                      fontWeight: "700",
                      lineHeight: "33px",
                    },
                  })}
                >
                  {count}{" "}
                  <VuiTypography
                    variant="button"
                    color={percentage.color}
                    fontWeight="bold"
                    sx={({ breakpoints }) => ({
                      [breakpoints.only("lg")]: {
                        fontSize: "10px",
                      },
                      [breakpoints.only("xl")]: {
                        fontSize: "12px",
                      },
                    })}
                  >
                    {percentage.text}
                  </VuiTypography>
                  {show && (
                    <PopUp onClick={createRepeat} />
                  )}
                </VuiTypography>
              </VuiBox>
            </Grid>
            {direction === "right" && icon ? (
              <Grid item xs={4}>
                <VuiBox
                  bgColor="#0075FF"
                  color="white"
                  width="45px"
                  height="45px"
                  marginLeft="auto"
                  borderRadius="lg"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  shadow="md"
                >
                  {icon}
                </VuiBox>
              </Grid>
            ) : null}
          </Grid>
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

// Setting default values for the props of AppStatisticsCard
AppStatisticsCard.defaultProps = {
  bgColor: "white",
  title: {
    fontWeight: "medium",
    text: "",
  },
  percentage: {
    color: "success",
    text: "",
  },
  direction: "right",
};

// Typechecking props for the AppStatisticsCard
AppStatisticsCard.propTypes = {
  bgColor: PropTypes.oneOf([
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  title: PropTypes.PropTypes.shape({
    fontWeight: PropTypes.oneOf(["light", "regular", "medium", "bold"]),
    text: PropTypes.string,
  }),
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  icon: PropTypes.shape({
    color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
    component: PropTypes.node.isRequired,
  }),
  direction: PropTypes.oneOf(["right", "left"]),
};
